import AddChatbot from "../../components/add-chatbot";
import { IProductParams } from "../../model";
import { useLocation, useNavigate } from "react-router-dom";

const AddChatbots = (props: any) => {
  const location = useLocation();
  return <AddChatbot />;
};

export default AddChatbots;
